export const SystemConstants = {
	API_LOADER: {
		TRIGGER_SUFFIX: "_API_REQUEST",
		SUCCESS_SUFFIX: "_API_SUCCESS",
		ERROR_SUFFIX: "_API_ERROR",
	},
	BACKEND_SERVER: {
		PROTRACK: process.env.REACT_APP_PROTRACK_SERVER,
	},
	DATE_FORMAT: 'DD-MM-YYYY',
	DATETIME_DATABASE_FORMAT: 'YYYY-MM-DD HH:mm:ss',
	DATETIME_FORMAT: 'YYYY-MM-DD HH:mm',
	DATETIME_FORMAT_DISPLAY: 'DD-MM-YYYY HH:mm:ss',
	DATETIME_QUERY: (isStart: boolean) => isStart ? 'YYYY-MM-DD 00:00:01' : 'YYYY-MM-DD 23:59:59',
	INVOICE_FEATURE_FLAG: process.env.REACT_APP_INVOICE_FEATURE_FLAG !== "0",
	PASSWORD_LENGTH: 5,
	REPORTS: {
		FONT: {
			FAMILY: "Helvetica",
			SIZE: 9,
			BOLD: "bold",
			NORMAL: "normal",
		},
	},
	NEXT_SERVICE_DEBIT_RANGE: 5,
}